import React from "react";

import Link from "../atoms/link";
import * as styles from "./minimal-footer.module.scss";
import logoAMComp from "../../assets/images/logo_amc_gold.png";

const MinimalFooter: React.FC = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className={styles.footer}>
            <p>Copyright © {currentYear} Fashion Fairy</p>
            <a
                className={styles.development}
                href="https://amcomp.pl"
                target="_blank"
                rel="noreferrer noopener"
            >
                <span>Development by</span>
                <img src={logoAMComp} alt="AMCOMP" />
            </a>
            <nav aria-label="Linki w stopce">
                <a
                    href="/docs/regulamin-serwisu.pdf"
                    target="_blank"
                    rel="noreferrer noopener"
                >
                    Regulamin
                </a>
                <a
                    href="/docs/polityka-prywatnosci.pdf"
                    target="_blank"
                    rel="noreferrer noopener"
                >
                    Polityka prywatności
                </a>
                <Link to="/faq/">FAQ</Link>
            </nav>
        </footer>
    );
};

export default MinimalFooter;
